import { FormattedMessage } from 'dibs-react-intl';
import { FunctionComponent, MouseEventHandler, useEffect } from 'react';
import { connect } from 'react-redux';
import { graphql, useFragment } from 'react-relay';

import { saveSidemark } from '../../actions/checkoutUIActions';
import { PaneState, isOnSidemarkPane } from '../../reducers/checkoutPaneReducer';

// components
import CheckoutSidebarPane from '../CheckoutSidebarPane';
import CheckoutSidebarSidemarkForm from './CheckoutSidebarSidemarkForm';

import {
    CheckoutSidebarSidemarkPane_transaction$data,
    CheckoutSidebarSidemarkPane_transaction$key,
} from './__generated__/CheckoutSidebarSidemarkPane_transaction.graphql';
import { CheckoutSidebarSidemarkPane_viewer$key } from './__generated__/CheckoutSidebarSidemarkPane_viewer.graphql';

const title = (
    <FormattedMessage
        id="checkout.CheckoutSidebarSidemarkPane.title"
        defaultMessage="Notes (Optional)"
    />
);

type Props = {
    isOnSidemark: boolean;
    onSaveSidemark: typeof saveSidemark;
    onClick: MouseEventHandler;
    viewer: CheckoutSidebarSidemarkPane_viewer$key;
    transaction: CheckoutSidebarSidemarkPane_transaction$key;
};

const CheckoutSidebarSidemarkPane: FunctionComponent<Props> = props => {
    const {
        isOnSidemark,
        onSaveSidemark,
        onClick,
        transaction: transactionRef,
        viewer: viewerRef,
    } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutSidebarSidemarkPane_viewer on Viewer {
                ...CheckoutSidebarSidemarkForm_viewer
            }
        `,
        viewerRef
    );

    const transaction = useFragment(
        graphql`
            fragment CheckoutSidebarSidemarkPane_transaction on Transaction {
                ...CheckoutSidebarSidemarkForm_transaction
                sidemark {
                    content
                }
            }
        `,
        transactionRef
    );

    useEffect(() => {
        const sidemark = (transaction?.sidemark?.content || '').trim();
        if (sidemark) {
            onSaveSidemark(sidemark, 'load');
        }
    }, [onSaveSidemark, transaction]);

    return (
        <CheckoutSidebarPane
            title={title}
            isClickable
            dataTn={'checkout-sidemark-pane'}
            onClick={onClick}
            isExpanded={isOnSidemark}
            showBar
        >
            <CheckoutSidebarSidemarkForm viewer={viewer} transaction={transaction} />
        </CheckoutSidebarPane>
    );
};

type ConnectedProps = {
    transaction: CheckoutSidebarSidemarkPane_transaction$data;
    pane: PaneState;
};

export default connect(
    ({ transaction, pane }: ConnectedProps) => ({
        sidemark: transaction.sidemark,
        isOnSidemark: isOnSidemarkPane(pane),
    }),
    {
        onSaveSidemark: saveSidemark,
    }
)(CheckoutSidebarSidemarkPane);
